'use strict'

document.addEventListener("DOMContentLoaded", function(event) {
    /********************************
     * Play video
     *******************************/
    const header = document.querySelector('.header').offsetHeight;
    const videoSection = document.querySelector('.video-section');
    const sectionTop = videoSection.offsetTop;
    const sectionHeight = videoSection.getBoundingClientRect().top +  videoSection.offsetHeight;


    window.addEventListener('scroll', function() {
        const iframe = videoSection.querySelector('.video-box iframe');
        const player = new Vimeo.Player(iframe);

        if(window.pageYOffset >= vh(100) && window.pageYOffset <= ( sectionHeight - header ) ){
            player.setVolume(0);
            player.play();
        }else{
            player.pause();
        }
    });

    function vh(percent) {
        var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        return (percent * h) / 100;
    }

});

